// @flow

import type { Action } from './store.type';

type MerchandisingV2RuleType = {
  tenant_id: string,
  name: string,
  effectFrom: string,
  effectTo: string,
  scopes: Array<string>,
  status: string,
  search: Object,
  conditions: Array<string>,
  consequences: Array<Object>
};

type MerchandisingV2RulesSuccess = {
  data: Array<MerchandisingV2RuleType>,
  total: number,
  totalRules: number,
  waitSyncAt: number,
  scheduleSyncIn: number,
  scheduleSyncAfter: number
};

type MerchandisingV2RuleSuccess = {
  data: MerchandisingV2RuleType,
  actionName: string,
  waitSyncAt: number,
  scheduleSyncIn: number,
  scheduleSyncAfter: number
};

type MerchandisingV2Failure = {
  error: any
};
/* #region: Get merchandising v2 rules */
export const ENABLED_MERCHANDISING_V2_RULES_REQUEST = 'ENABLED_MERCHANDISING_V2_RULES_REQUEST';
type ENABLED_MERCHANDISING_V2_RULES_REQUEST_TYPE = 'ENABLED_MERCHANDISING_V2_RULES_REQUEST';

export const ENABLED_MERCHANDISING_V2_RULES_SUCCESS = 'ENABLED_MERCHANDISING_V2_RULES_SUCCESS';
type ENABLED_MERCHANDISING_V2_RULES_SUCCESS_TYPE = 'ENABLED_MERCHANDISING_V2_RULES_SUCCESS';

export const ENABLED_MERCHANDISING_V2_RULES_FAILURE = 'ENABLED_MERCHANDISING_V2_RULES_FAILURE';
type ENABLED_MERCHANDISING_V2_RULES_FAILURE_TYPE = 'ENABLED_MERCHANDISING_V2_RULES_FAILURE';

type EnabledMerchandisingV2RulesRequestAction = Action<
  ENABLED_MERCHANDISING_V2_RULES_REQUEST_TYPE,
  null
>;

type EnabledMerchandisingV2RulesSuccessAction = Action<
  ENABLED_MERCHANDISING_V2_RULES_SUCCESS_TYPE,
  { data: MerchandisingV2RulesSuccess }
>;

type EnabledMerchandisingV2RulesFailureAction = Action<
  ENABLED_MERCHANDISING_V2_RULES_FAILURE_TYPE,
  MerchandisingV2Failure
>;

/* #region: Get merchandising v2 rules */
export const GET_MERCHANDISING_V2_RULES_REQUEST = 'GET_MERCHANDISING_V2_RULES_REQUEST';
type GET_MERCHANDISING_V2_RULES_REQUEST_TYPE = 'GET_MERCHANDISING_V2_RULES_REQUEST';

export const GET_MERCHANDISING_V2_RULES_SUCCESS = 'GET_MERCHANDISING_V2_RULES_SUCCESS';
type GET_MERCHANDISING_V2_RULES_SUCCESS_TYPE = 'GET_MERCHANDISING_V2_RULES_SUCCESS';

export const GET_MERCHANDISING_V2_RULES_FAILURE = 'GET_MERCHANDISING_V2_RULES_FAILURE';
type GET_MERCHANDISING_V2_RULES_FAILURE_TYPE = 'GET_MERCHANDISING_V2_RULES_FAILURE';

type GetMerchandisingV2RulesRequestAction = Action<GET_MERCHANDISING_V2_RULES_REQUEST_TYPE, null>;

type GetMerchandisingV2RulesSuccessAction = Action<
  GET_MERCHANDISING_V2_RULES_SUCCESS_TYPE,
  { data: MerchandisingV2RulesSuccess }
>;

type GetMerchandisingV2RulesFailureAction = Action<
  GET_MERCHANDISING_V2_RULES_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Get merchandising v2 rule */
export const GET_MERCHANDISING_V2_RULE_REQUEST = 'GET_MERCHANDISING_V2_RULE_REQUEST';
type GET_MERCHANDISING_V2_RULE_REQUEST_TYPE = 'GET_MERCHANDISING_V2_RULE_REQUEST';

export const GET_MERCHANDISING_V2_RULE_SUCCESS = 'GET_MERCHANDISING_V2_RULE_SUCCESS';
type GET_MERCHANDISING_V2_RULE_SUCCESS_TYPE = 'GET_MERCHANDISING_V2_RULE_SUCCESS';

export const GET_MERCHANDISING_V2_RULE_FAILURE = 'GET_MERCHANDISING_V2_RULE_FAILURE';
type GET_MERCHANDISING_V2_RULE_FAILURE_TYPE = 'GET_MERCHANDISING_V2_RULE_FAILURE';

type GetMerchandisingV2RuleRequestAction = Action<GET_MERCHANDISING_V2_RULE_REQUEST_TYPE, null>;

type GetMerchandisingV2RuleSuccessAction = Action<
  GET_MERCHANDISING_V2_RULE_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type GetMerchandisingV2RuleFailureAction = Action<
  GET_MERCHANDISING_V2_RULE_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Create merchandising v2 rule */
export const CREATE_MERCHANDISING_RULE_V2_REQUEST = 'CREATE_MERCHANDISING_RULE_V2_REQUEST';
type CREATE_MERCHANDISING_RULE_V2_REQUEST_TYPE = 'CREATE_MERCHANDISING_RULE_V2_REQUEST';

export const CREATE_MERCHANDISING_RULE_V2_SUCCESS = 'CREATE_MERCHANDISING_RULE_V2_SUCCESS';
type CREATE_MERCHANDISING_RULE_V2_SUCCESS_TYPE = 'CREATE_MERCHANDISING_RULE_V2_SUCCESS';

export const CREATE_MERCHANDISING_RULE_V2_FAILURE = 'CREATE_MERCHANDISING_RULE_V2_FAILURE';
type CREATE_MERCHANDISING_RULE_V2_FAILURE_TYPE = 'CREATE_MERCHANDISING_RULE_V2_FAILURE';

type CreateMerchandisingRuleV2RequestAction = Action<
  CREATE_MERCHANDISING_RULE_V2_REQUEST_TYPE,
  null
>;

type CreateMerchandisingRuleV2SuccessAction = Action<
  CREATE_MERCHANDISING_RULE_V2_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type CreateMerchandisingRuleV2FailureAction = Action<
  CREATE_MERCHANDISING_RULE_V2_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Update merchandising v2 rule */
export const UPDATE_MERCHANDISING_V2_RULE_REQUEST = 'UPDATE_MERCHANDISING_V2_RULE_REQUEST';
type UPDATE_MERCHANDISING_V2_RULE_REQUEST_TYPE = 'UPDATE_MERCHANDISING_V2_RULE_REQUEST';

export const UPDATE_MERCHANDISING_V2_RULE_SUCCESS = 'UPDATE_MERCHANDISING_V2_RULE_SUCCESS';
type UPDATE_MERCHANDISING_V2_RULE_SUCCESS_TYPE = 'UPDATE_MERCHANDISING_V2_RULE_SUCCESS';

export const UPDATE_MERCHANDISING_V2_RULE_FAILURE = 'UPDATE_MERCHANDISING_V2_RULE_FAILURE';
type UPDATE_MERCHANDISING_V2_RULE_FAILURE_TYPE = 'UPDATE_MERCHANDISING_V2_RULE_FAILURE';

type UpdateMerchandisingV2RequestAction = Action<UPDATE_MERCHANDISING_V2_RULE_REQUEST_TYPE, null>;

type UpdateMerchandisingV2SuccessAction = Action<
  UPDATE_MERCHANDISING_V2_RULE_SUCCESS_TYPE,
  { data: MerchandisingV2RuleSuccess, actionName: string }
>;

type UpdateMerchandisingV2FailureAction = Action<
  UPDATE_MERCHANDISING_V2_RULE_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Delete merchandising v2 rule */
export const DELETE_MERCHANDISING_V2_RULE_REQUEST = 'DELETE_MERCHANDISING_V2_RULE_REQUEST';
type DELETE_MERCHANDISING_V2_RULE_REQUEST_TYPE = 'DELETE_MERCHANDISING_V2_RULE_REQUEST';

export const DELETE_MERCHANDISING_V2_RULE_SUCCESS = 'DELETE_MERCHANDISING_V2_RULE_SUCCESS';
type DELETE_MERCHANDISING_V2_RULE_SUCCESS_TYPE = 'DELETE_MERCHANDISING_V2_RULE_SUCCESS';

export const DELETE_MERCHANDISING_V2_RULE_FAILURE = 'DELETE_MERCHANDISING_V2_RULE_FAILURE';
type DELETE_MERCHANDISING_V2_RULE_FAILURE_TYPE = 'DELETE_MERCHANDISING_V2_RULE_FAILURE';

type DeleteMerchandisingV2RequestAction = Action<DELETE_MERCHANDISING_V2_RULE_REQUEST_TYPE, null>;

type DeleteMerchandisingV2SuccessAction = Action<
  DELETE_MERCHANDISING_V2_RULE_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type DeleteMerchandisingV2FailureAction = Action<
  DELETE_MERCHANDISING_V2_RULE_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Duplicate merchandising v2 rule */
export const DUPLICATE_MERCHANDISING_V2_RULE_REQUEST = 'DUPLICATE_MERCHANDISING_V2_RULE_REQUEST';
type DUPLICATE_MERCHANDISING_V2_RULE_REQUEST_TYPE = 'DUPLICATE_MERCHANDISING_V2_RULE_REQUEST';

export const DUPLICATE_MERCHANDISING_V2_RULE_SUCCESS = 'DUPLICATE_MERCHANDISING_V2_RULE_SUCCESS';
type DUPLICATE_MERCHANDISING_V2_RULE_SUCCESS_TYPE = 'DUPLICATE_MERCHANDISING_V2_RULE_SUCCESS';

export const DUPLICATE_MERCHANDISING_V2_RULE_FAILURE = 'DUPLICATE_MERCHANDISING_V2_RULE_FAILURE';
type DUPLICATE_MERCHANDISING_V2_RULE_FAILURE_TYPE = 'DUPLICATE_MERCHANDISING_V2_RULE_FAILURE';

type DuplicateMerchandisingV2RequestAction = Action<
  DUPLICATE_MERCHANDISING_V2_RULE_REQUEST_TYPE,
  null
>;

type DuplicateMerchandisingV2SuccessAction = Action<
  DUPLICATE_MERCHANDISING_V2_RULE_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type DuplicateMerchandisingV2FailureAction = Action<
  DUPLICATE_MERCHANDISING_V2_RULE_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Render preview merchandising */
export const PREVIEW_MERCHANDISING_V2_RULE_REQUEST = 'PREVIEW_MERCHANDISING_V2_RULE_REQUEST';
type PREVIEW_MERCHANDISING_V2_RULE_REQUEST_TYPE = 'PREVIEW_MERCHANDISING_V2_RULE_REQUEST';

export const PREVIEW_MERCHANDISING_V2_RULE_SUCCESS = 'PREVIEW_MERCHANDISING_V2_RULE_SUCCESS';
type PREVIEW_MERCHANDISING_V2_RULE_SUCCESS_TYPE = 'PREVIEW_MERCHANDISING_V2_RULE_SUCCESS';

export const PREVIEW_MERCHANDISING_V2_RULE_FAILURE = 'PREVIEW_MERCHANDISING_V2_RULE_FAILURE';
type PREVIEW_MERCHANDISING_V2_RULE_FAILURE_TYPE = 'PREVIEW_MERCHANDISING_V2_RULE_FAILURE';

type PreviewMerchandisingV2RequestAction = Action<PREVIEW_MERCHANDISING_V2_RULE_REQUEST_TYPE, null>;

type PreviewMerchandisingV2SuccessAction = Action<
  PREVIEW_MERCHANDISING_V2_RULE_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type PreviewMerchandisingV2FailureAction = Action<
  PREVIEW_MERCHANDISING_V2_RULE_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Render preview merchandising */
export const GET_PRODUCTS_WITH_FILTER_CONDITIONS_REQUEST =
  'GET_PRODUCTS_WITH_FILTER_CONDITIONS_REQUEST';
type GET_PRODUCTS_WITH_FILTER_CONDITIONS_REQUEST_TYPE =
  'GET_PRODUCTS_WITH_FILTER_CONDITIONS_REQUEST';

export const GET_PRODUCTS_WITH_FILTER_CONDITIONS_SUCCESS =
  'GET_PRODUCTS_WITH_FILTER_CONDITIONS_SUCCESS';
type GET_PRODUCTS_WITH_FILTER_CONDITIONS_SUCCESS_TYPE =
  'GET_PRODUCTS_WITH_FILTER_CONDITIONS_SUCCESS';

export const GET_PRODUCTS_WITH_FILTER_CONDITIONS_FAILURE =
  'GET_PRODUCTS_WITH_FILTER_CONDITIONS_FAILURE';
type GET_PRODUCTS_WITH_FILTER_CONDITIONS_FAILURE_TYPE =
  'GET_PRODUCTS_WITH_FILTER_CONDITIONS_FAILURE';

type GetProductsWithFilterConditionsRequestAction = Action<
  GET_PRODUCTS_WITH_FILTER_CONDITIONS_REQUEST_TYPE,
  null
>;

type GetProductsWithFilterConditionsSuccessAction = Action<
  GET_PRODUCTS_WITH_FILTER_CONDITIONS_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type GetProductsWithFilterConditionsFailureAction = Action<
  GET_PRODUCTS_WITH_FILTER_CONDITIONS_FAILURE_TYPE,
  MerchandisingV2Failure
>;
/* #endregion */

/* #region: Render preview merchandising */
export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
type GET_PRODUCTS_REQUEST_TYPE = 'GET_PRODUCTS_REQUEST';

export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
type GET_PRODUCTS_SUCCESS_TYPE = 'GET_PRODUCTS_SUCCESS';

export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE';
type GET_PRODUCTS_FAILURE_TYPE = 'GET_PRODUCTS_FAILURE';

type GetProductsRequestAction = Action<GET_PRODUCTS_REQUEST_TYPE, null>;

type GetProductsSuccessAction = Action<GET_PRODUCTS_SUCCESS_TYPE, MerchandisingV2RuleSuccess>;

type GetProductsAction = Action<GET_PRODUCTS_FAILURE_TYPE, MerchandisingV2Failure>;
/* #endregion */

/* #region: Reset merchandising v2 rule */
export const RESET_MERCHANDISING_V2_RULE = 'RESET_MERCHANDISING_V2_RULE';
type RESET_MERCHANDISING_V2_RULE_TYPE = 'RESET_MERCHANDISING_V2_RULE';
type ResetMerchandisingV2Rule = Action<RESET_MERCHANDISING_V2_RULE_TYPE, {}>;
/* #endregion */

/* #region: Render preview merchandising */
export const GET_EXISTS_UNIVERSAL_RULE_REQUEST = 'GET_EXISTS_UNIVERSAL_RULE_REQUEST';
type GET_EXISTS_UNIVERSAL_RULE_REQUEST_TYPE = 'GET_EXISTS_UNIVERSAL_RULE_REQUEST';

export const GET_EXISTS_UNIVERSAL_RULE_SUCCESS = 'GET_EXISTS_UNIVERSAL_RULE_SUCCESS';
type GET_EXISTS_UNIVERSAL_RULE_SUCCESS_TYPE = 'GET_EXISTS_UNIVERSAL_RULE_SUCCESS';

export const GET_EXISTS_UNIVERSAL_RULE_FAILURE = 'GET_EXISTS_UNIVERSAL_RULE_FAILURE';
type GET_EXISTS_UNIVERSAL_RULE_FAILURE_TYPE = 'GET_EXISTS_UNIVERSAL_RULE_FAILURE';

type GetExistsURRequestAction = Action<GET_EXISTS_UNIVERSAL_RULE_REQUEST_TYPE, null>;

type GetExistsURSuccessAction = Action<
  GET_EXISTS_UNIVERSAL_RULE_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;

type GetExistsURAction = Action<GET_EXISTS_UNIVERSAL_RULE_FAILURE_TYPE, MerchandisingV2Failure>;

export const CHECK_DUPLICATE_TERM_REQUEST = 'CHECK_DUPLICATE_TERM_REQUEST';
type CHECK_DUPLICATE_TERM_REQUEST_TYPE = 'CHECK_DUPLICATE_TERM_REQUEST';

export const CHECK_DUPLICATE_TERM_SUCCESS = 'CHECK_DUPLICATE_TERM_SUCCESS';
type CHECK_DUPLICATE_TERM_SUCCESS_TYPE = 'CHECK_DUPLICATE_TERM_SUCCESS';

export const CHECK_DUPLICATE_TERM_FAILURE = 'CHECK_DUPLICATE_TERM_FAILURE';

type CheckDuplicateTermRequestAction = Action<CHECK_DUPLICATE_TERM_REQUEST_TYPE, null>;

type CheckDuplicateTermSuccessAction = Action<
  CHECK_DUPLICATE_TERM_SUCCESS_TYPE,
  MerchandisingV2RuleSuccess
>;
/* #endregion */

// Action and State
export type MerchandisingV2Action =
  | EnabledMerchandisingV2RulesRequestAction
  | EnabledMerchandisingV2RulesSuccessAction
  | EnabledMerchandisingV2RulesFailureAction
  | GetMerchandisingV2RuleRequestAction
  | GetMerchandisingV2RuleSuccessAction
  | GetMerchandisingV2RuleFailureAction
  | GetMerchandisingV2RulesRequestAction
  | GetMerchandisingV2RulesSuccessAction
  | GetMerchandisingV2RulesFailureAction
  | CreateMerchandisingRuleV2RequestAction
  | CreateMerchandisingRuleV2SuccessAction
  | CreateMerchandisingRuleV2FailureAction
  | UpdateMerchandisingV2RequestAction
  | UpdateMerchandisingV2SuccessAction
  | UpdateMerchandisingV2FailureAction
  | DeleteMerchandisingV2RequestAction
  | DeleteMerchandisingV2SuccessAction
  | DeleteMerchandisingV2FailureAction
  | DuplicateMerchandisingV2RequestAction
  | DuplicateMerchandisingV2SuccessAction
  | DuplicateMerchandisingV2FailureAction
  | PreviewMerchandisingV2RequestAction
  | PreviewMerchandisingV2SuccessAction
  | PreviewMerchandisingV2FailureAction
  | GetProductsWithFilterConditionsRequestAction
  | GetProductsWithFilterConditionsSuccessAction
  | GetProductsWithFilterConditionsFailureAction
  | GetProductsRequestAction
  | GetProductsSuccessAction
  | GetProductsAction
  | ResetMerchandisingV2Rule
  | GetExistsURRequestAction
  | GetExistsURSuccessAction
  | GetExistsURAction
  | CheckDuplicateTermRequestAction
  | CheckDuplicateTermSuccessAction;

export type MerchandisingV2State = {
  loading: boolean,
  saving: boolean,
  deleting: boolean,
  duplicating: boolean,
  renderingPreview: boolean,
  loadingProducts: boolean,
  success: boolean,
  saveSuccess: boolean,
  renderingPreviewSuccess: boolean,
  previewRequestBody: string,
  loadingProductsSuccess: boolean,
  error: null,
  total: number,
  totalRules: number,
  merchandisingRules: Array<MerchandisingV2RuleType>,
  merchandisingRule: MerchandisingV2RuleType | {},
  duplicateRule: MerchandisingV2RuleType | {},
  previewProducts: Array<Object>,
  previewTotalProduct: number,
  productsWithFilterConditions: Array<Object>,
  productsWithFilterConditionsCount: number,
  enableSortByRelevance: boolean,
  enableSortByManual: boolean,
  duplicateTerm: Record<string, Object>
};
